<template>
  <el-dialog
    :visible.sync="DialogShow"
    @closed="closeDialog"
    @open="openDialog"
    append-to-body
  >
    <div slot="title" class="dialog-title">
      <span class="title-line"></span>
      <span class="title-text">{{ title }}</span>
    </div>
    <el-form
      :model="submitFormData"
      :rules="rules"
      ref="form"
      label-width="160px"
      class="demo-submitFormData"
      style="padding: 20px 0 10px 60px"
    >
      <el-form-item label="电子表单" prop="formName">
        <el-input v-model="submitFormData.formName" class="long-inp"></el-input>
      </el-form-item>
      <el-form-item label="上传文件" prop="templateFileBid">
        <el-upload
          class="avatar-uploader"
          :action="`${uploadfileUrl}/fileManager/uploadPicture`"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :on-error="handleAvatarError"
          :before-remove="handleAvatarRemove"
          :on-change="uploadChange"
          :before-upload="beforeFileUpload"
          name="file"
          :headers="{ token }"
        >
          <el-button size="small" type="primary">上传样例</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <div class="from-btn-wrap">
      <el-button type="primary" @click="handelClickSubmit" size="small">{{
        upDataMsg
      }}</el-button>
      <el-button type="primary" plain size="small" @click="handelClickCancel"
        >取消</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import {
  electronicFormCreate,
  electronicFormUpdate,
} from '@/api/electronicForm';
import { clone } from '@/utils/utils';
const defaultUpdataObj = {
  formName: '',
  templateFileBid: '',
  formBid: '',
};
export default {
  data() {
    return {
      upDataMsg: '保存',
      token: '',
      DialogShow: false,
      submitFormData: clone(defaultUpdataObj),
      templateFileUrl: '',
      rules: {
        formName: [
          { required: true, message: '请输入电子表单名称', trigger: 'blur' },
        ],
        templateFileBid: [
          { required: true, message: '请上传图片', trigger: 'change' },
        ],
      },
    };
  },
  props: {
    title: {
      type: String,
      default: function () {
        return '';
      },
    },
    formObj: {
      type: Object,
      default: '',
    },
  },
  methods: {
    openDialog() {
      this.token = localStorage.getItem('token');
      if (this.formObj.formBid) {
        this.templateFileUrl = this.formObj.templateFileUrl;
        Object.assign(this.submitFormData, this.formObj);
      }
    },
    handelClickSubmit() {
      if (this.upDataMsg == '保存') {
        this.$refs.form.validate((valid) => {
          if (!valid) {
            return false;
          } else {
            this.upDataMsg = '保存中..';
            if (!this.formObj.formBid) {
              electronicFormCreate(this.submitFormData).then((res) => {
                if (res.code == 200) {
                  this.$msg.success('保存成功！');
                  this.$emit('upData');
                  this.closeDialog();
                }
              });
              this.upDataMsg = '保存';
            } else {
              electronicFormUpdate(this.submitFormData).then((res) => {
                if (res.code == 200) {
                  this.$msg.success('保存成功！');
                  this.$emit('upData');
                  this.closeDialog();
                }
              });
              this.upDataMsg = '保存';
            }
          }
        });
      }
    },
    handelClickCancel() {
      this.closeDialog();
    },
    closeDialog() {
      this.templateFileUrl = '';
      this.DialogShow = false;
      this.$refs.form.resetFields();
    },
    //上传部分--------------------------------------------------------
    handleAvatarSuccess(res) {
      this.duration = 10;
      this.$msg.success('上传成功');
      this.duration = 0;
      this.templateFileUrl = res.data.fileUrl;
      this.submitFormData.templateFileBid = res.data.fileBid;
      this.$refs.form.clearValidate('templateFileBid');
    },
    handleAvatarError(error) {
      console.log(error);
      this.$msg.error('上传失败');
    },
    handleAvatarRemove() {
      this.$msg.error('上传失败!');
    },
    uploadChange(file, fileList) {
      this.fileList = fileList;
    },
    uploadChange(file, fileList) {
      this.fileList = fileList;
    },
    beforeFileUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!');
        return;
      } else {
        // this.type = true;
        this.$msg({
          duration: this.duration,
          message: '上传中',
          showClose: true,
        });
      }
      return isLt10M;
    },
  },
  computed: {
    uploadfileUrl() {
      return this.$conf.visaService;
    },
  },
};
</script>

<style>
</style>